import React from 'react'
import {Mask} from 'react-weui'
import rebateModalImg from '../../images/liveroom/rebate-modal.png'
import {WKVisible} from '../../components/wk'


class LiveroomRebateModal extends React.Component {
    render() {
        return (
            <div className="liveroom-rebate-modal">
                <WKVisible show={this.props.show}>
                    <Mask onClick={this.props.onClickMask} />
                    <div className="content">
                        <img src={rebateModalImg} />
                        <div className="qr">
                            <img src={this.props.qrImg || ''} />
                        </div>
                    </div>
                </WKVisible>
            </div>
        )
    }
}

export default LiveroomRebateModal


// WEBPACK FOOTER //
// ./src/pages/liveroomCreate/LiveroomRebateModal.js